import { User, useWhoamiQuery } from 'graphql-common';
import _get from 'lodash/get';
import { WatchQueryFetchPolicy } from '@apollo/client';

type Args = {
  fetchPolicy?: WatchQueryFetchPolicy;
};

export default function useWhoamiQueryHook(args?: Args) {
  const { fetchPolicy } = args || {};
  const { data, previousData, error, refetch, loading, networkStatus } =
    useWhoamiQuery({
      fetchPolicy: fetchPolicy || 'cache-and-network',
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
    });
  // A network error (e.g. a background refetch going out while offline)
  // clears Apollo's `data` to `undefined` even though the previous fetch
  // already succeeded — Apollo only keeps that prior payload on
  // `previousData`. Falling back to it here keeps `data` pointing at the
  // last known session instead of looking like the user was never
  // authenticated. See DAT-1534.
  const effectiveData = data ?? previousData;
  const currentUser = _get(effectiveData, 'whoami.resource') as User;
  const currentUserDeactivatedAt = currentUser?.deactivatedAt;
  const currentUserEmail = currentUser?.email;
  const currentUserId = currentUser?.id;
  const currentUserLang = currentUser?.lang;
  const currentUserUnconfirmedEmail = currentUser?.unconfirmedEmail;
  const currentUserUsername = currentUser?.username;
  const firstLoading = loading && effectiveData === undefined;
  return {
    currentUser,
    currentUserDeactivatedAt,
    currentUserEmail,
    currentUserId,
    currentUserLang,
    currentUserUnconfirmedEmail,
    currentUserUsername,
    data: effectiveData,
    error,
    firstLoading,
    loading,
    networkStatus,
    refetch,
  };
}
